export const FORM_ENTITY_IDS_PARAM_NAME = 'formEntityIds';
export const FORM_ENTITY_IDS_PARAM_TEMPLATE = `/:${FORM_ENTITY_IDS_PARAM_NAME}?`;
